import { MapDrawingConfig } from "./canvas-drawing";
import {
  mapRenderSizeFromPreset,
  screenSizeFromPreset,
  borderWidthInPixels,
} from "PosterEditor/model/poster-project";
import { Size } from "PosterEditor/model/poster-types";
import { PosterProject, GPSSource } from "PosterEditor/model/poster-project";
import { drawMapElements } from "./canvas-drawing";
import { defaultEditingPermissions } from "PosterEditor/model/default-project-style";

export interface CanvasRenderConfig {
  map: React.MutableRefObject<any>;
  originalMapSize: Size;
  project: PosterProject;
  gpsSource: GPSSource | undefined;
}

export const getCanvasRender = async (config: CanvasRenderConfig) => {
  const offscreenCanvas = document.createElement("canvas");
  const offscreenRef = { current: offscreenCanvas }; // 👈 Wrap it

  const mapSize = mapRenderSizeFromPreset(
    config.project.size,
    config.project.borderStyle.borderWidth ?? 0
  );

  offscreenCanvas.width = mapSize.width;
  offscreenCanvas.height = mapSize.height;
  const screenSize = screenSizeFromPreset(config.project.size);

  const screenBorderWidth = borderWidthInPixels(
    config.project.borderStyle.borderWidth ?? 0,
    config.project.size
  );
  const screenMapWidth = screenSize.width - screenBorderWidth * 2;
  const scale = mapSize.width / screenMapWidth;

  const drawingConfig: MapDrawingConfig = {
    map: config.map,
    canvasElement: offscreenRef,
    originalMapSize: config.originalMapSize,
    scale: scale,
    project: config.project,
    gpsSource: config.gpsSource,
    dotGridSpacing: undefined,
    pointerLocation: undefined,
    pointerInteruptRadius: 50,
    elementToHighlight: undefined,
    selectedElement: undefined,
    isRendering: true,
    projectEditingPermissions: defaultEditingPermissions,
    isTemplateEditing: false,
  };
  drawMapElements(drawingConfig);

  const blob = await new Promise<Blob>((resolve) =>
    offscreenCanvas.toBlob((b) => resolve(b!), "image/png")
  );
  return blob;
};
